export default "__VITE_ASSET__PuyqQ58a__"